/* eslint-disable react/jsx-props-no-multi-spaces */
import Desktop from "./dekstop";
import Mobile from "./mobile";

const TabUser = (props) => {

	const prop = props;

	if (prop.isMobile) {

		return (
			<Mobile
				{...prop}
			/>
		);

	}
	return (
		<Desktop {...prop} />
	);

};

export default TabUser;
